import { useState } from "react";
import { useTranslation } from "react-i18next";
import { enviroment } from "../../../enviroment";
import { ConsentDialog } from "../../components/ConsentBanner/ConsentDialog";
import { useWhiteLabelContext } from "../../../WhiteLabelContext";
import { useProfileContext } from "../../../contexts/ProfileContext";
import { Role } from "../../../core/models/entities/Role";
import Brand from "../../components/customer-brand/Brand";
import { CLARITY_MASK } from "../../../utils/analytics/clarityAttrs";

// Flag REACT_APP_CLARITY_CONSENT_ENABLED: "Cookie settings" text link next
// to the copyright + the dialog. Off = neither exists = byte-identical DOM.
// Also needs the privacy policy URL - the dialog renders nothing without it
// (no dead link).
const consentEnabled =
  enviroment.clarityConsentEnabled && !!enviroment.privacyPolicyUrl;

function MainFooter() {
  const { t } = useTranslation();
  const { profile } = useProfileContext();
  const { whiteLabel } = useWhiteLabelContext();
  const year = new Date().getFullYear();
  const [consentOpen, setConsentOpen] = useState(false);

  return (
    <footer className="w-full bg-white border-t border-gray-200 px-8">
      <div className="max-w-[90rem] h-16 w-full mx-auto flex items-center gap-x-10 justify-between">
        <Brand profile={profile!} />
        <p className={"font-[400] color-[#8D8D8D]"} {...CLARITY_MASK}>
          © {year}{" "}
          {whiteLabel?.whiteLabelCopyrightName ||
            (profile?.userOrganizationInformations.role === Role.Admin
              ? enviroment.brandName
              : "")}
          . {t("headerFooter.allRightsReserved")}
          {consentEnabled && (
            <>
              {" · "}
              <button
                type="button"
                className="underline hover:text-black"
                onClick={() => setConsentOpen(true)}
              >
                {t("consent.settings")}
              </button>
            </>
          )}
        </p>
      </div>
      {consentEnabled && (
        <ConsentDialog
          open={consentOpen}
          onClose={() => setConsentOpen(false)}
        />
      )}
    </footer>
  );
}

export default MainFooter;
